import ConnectionsList from '../../components/connections-list/ConnectionsList';
import FriendRequests from '../../components/friend-requests/FriendRequests';
import ProfileLeftPanel from '../../components/profile-left-panel/ProfileLeftPanel';
import ProfileMidPanel from '../../components/profile-mid-panel/ProfileMidPanel';
import ProfileSuggestions from '../../components/profile-suggestions/ProfileSuggestions';
import styles from './Connections.module.scss';

const Connections = () => {
  return (
    <main className={styles.connections}>
      <section className={styles.profileLeftPanel}>
        <ProfileLeftPanel />
      </section>
      <section className={styles.connectionsMidPanel}>
        <FriendRequests />
        <ConnectionsList />
      </section>
      <section className={styles.suggestions}>
        <ProfileSuggestions />
      </section>
    </main>
  );
};

export default Connections;
